import React, { useContext } from 'react';
import {
  Image, Row, Col, Loader, Button
} from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { func, bool } from 'prop-types';
import { getImageURL } from '../../common/utils/cardUtils';
import './WelcomeCardErrorPage.scss';
import '../../common/style/WelcomeCardGlobal.scss';

const WelcomeCardErrorPage = (props) => {
  const { handleOnClick, cardLoaded } = props;

  const RefreshButton = () => {
    return (
      <div className="WelcomeCardErrorPage__refreshMain">
        <Image
          width="24px"
          height="24px"
          // src="https://assets.thdstatic.com/images/loyaltyBenefits/ProTiers/icon-refresh.svg"
          src={getImageURL('ProTiers/icon-refresh.svg')}
          alt="refresh"
          className="WelcomeCardErrorPage__linkIcon "
        />
        <Button
          link
          transparent
          underline="true"
          className="WelcomeCardErrorPage__subLink"
          onClick={handleOnClick}
        >Refresh
        </Button>
      </div>
    );
  };

  const RefreshLabel = () => {
    const { channel } = useContext(ExperienceContext);
    return (
      <div className="Icon">
        <Col className="hidden-md-down">
          <Image
            width="45px"
            height="45px"
            // src="https://assets.thdstatic.com/images/v1/loyaltyBenefits/pro-extra-perk.svg"
            src={getImageURL('Pro-Xtra_Perk_Icon-whiteFill.svg')}
            alt="pro-extra-perk"
            className="WelcomeCardErrorPage__linkIcon"
          />
        </Col>

        <Col className="WelcomeCardErrorPage__label">
          Check Back For Your Loyalty Status
        </Col>

      </div>
    );
  };

  const SpinnerCard = () => {
    return (
      <div className="WelcomeCardErrorPage__spinnerContainer">
        <Loader active className="WelcomeCardErrorPage__cardLoader" />
      </div>
    );
  };

  return (
    <Col className="WelcomeCardErrorPage__welcomeErrorCard">
      <Row>
        {/*  <div className="hidden-xl-up  col__12-12">
          {/* <div className="col__6-12 WelcomeCardErrorPage__errorProLogo11">
           {/*  {cardLoaded && <WelcomeCardHeader />}
          </div>
          {cardLoaded && <div className="col__6-12"><RefreshButton /></div>}
        </div> */}
        <div className="col__12-12 WelcomeCardErrorPage__errorProLogo">
          {/*   {cardLoaded && <WelcomeCardHeader />} */}
          <div className="WelcomeCardErrorPage__loaderDesktopMain">
            {cardLoaded ? (
              <><RefreshLabel />
                <RefreshButton />
              </>
            ) : <SpinnerCard />}
          </div>
        </div>
        {/*   <div className="WelcomeCardErrorPage__loaderMain hidden-xl-up ">
          {cardLoaded ? <RefreshLabel /> : <SpinnerCard />}
        </div> */}
      </Row>
    </Col>
  );
};

WelcomeCardErrorPage.propTypes = {
  handleOnClick: func,
  cardLoaded: bool
};

WelcomeCardErrorPage.defaultProps = {
  handleOnClick: () => { },
  cardLoaded: true
};

export { WelcomeCardErrorPage };
